import React from 'react';
import { LuPencil, LuTrash2 } from 'react-icons/lu';

import { TaxableIncome } from '@ndvr/portfolio-api';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { formatCurrency, formatNumber, titleCase } from 'utils';

import { getIncomeScheduleText } from './tax-profile-utils';

interface TaxableIncomeCardProps {
    income: TaxableIncome;
    isActive?: boolean;
    showDeleteButton: boolean;
    onEdit: (income: TaxableIncome, isActive: boolean) => void;
    onDelete: (e: React.MouseEvent, income: TaxableIncome) => void;
}

export const TaxableIncomeCard = ({
    income,
    isActive = false,
    showDeleteButton,
    onEdit,
    onDelete,
}: TaxableIncomeCardProps) => {
    const handleEdit = (e: React.MouseEvent) => {
        e.stopPropagation();
        onEdit(income, isActive);
    };

    return (
        <Card key={income.taxableIncomeGUID} className="group relative border-b p-4">
            <div className="absolute top-2 right-2 flex gap-1 opacity-0 transition-opacity group-hover:opacity-100">
                <Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleEdit}>
                    <LuPencil className="h-4 w-4 text-gray-500 hover:text-blue-600" />
                </Button>
                {showDeleteButton && (
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={(e) => onDelete(e, income)}>
                        <LuTrash2 className="h-4 w-4 text-gray-500 hover:text-red-600" />
                    </Button>
                )}
            </div>
            <div className="font-medium">{income.title.plainText}</div>
            <div className="text-sm text-gray-600">{titleCase(income.taxableIncomeType)}</div>
            <div className="text-sm text-gray-600">
                {formatCurrency(income.amount)} {getIncomeScheduleText(income)}{' '}
            </div>
            {income.inflationConfig.inflationAdjusted && (
                <div className="text-gray-600">inflation adjusted at {income.inflationConfig.inflationPercent}%</div>
            )}
        </Card>
    );
};
